module.exports = __webpack_public_path__ + "media/images/Instagram-5ed117e40c056ffc1e81e82e43f3b60b.svg";